var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-title"},[_c('span',[_vm._t("default")],2),(_vm.titleimg)?_c('img',{staticClass:"pc-img",attrs:{"src":_vm.titleimg}}):_vm._e(),(_vm.stitleimg)?_c('img',{staticClass:"wap-img",attrs:{"src":_vm.stitleimg}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }